export default "__VITE_ASSET__CpK4AaPy__"